import { useMemo } from "react";
import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import { MinAvgMaxKeys } from "@repo/utils";
import {
  useEstimateStructure,
  useVisibilityModeCellClassName,
  useEstimateEditorSettings,
  ValueCell, useSummaryTimeInputTooltipAlert
} from "@tools";

export const HoursCell = observer(({
  element,
  ...props
}) => {
  const { allowEdition, useProfitability } = useEstimateEditorSettings();
  const structure = useEstimateStructure();
  const className = useVisibilityModeCellClassName(structure.visibility.hideSummaryHours);
  const tooltip = useSummaryTimeInputTooltipAlert(allowEdition);

  const { displayAnyValue, displayWorkTypeTwoValues } = structure;
  const {
    maxValuesAsBuffer,
    modifier,
    // showDecimals,
    usedRoundDecimals,
    isTimelineTableUsed,
  } = structure.settings;
  const {
    displayHours,
    displayHoursMax,
    availableHours,
    isOnlyResource,
  } = element;
  
  const editable = allowEdition && !isOnlyResource && !isTimelineTableUsed;
  
  const showMaxValue = useMemo(() => (
    displayWorkTypeTwoValues[element.workTypeId] && ((editable && !maxValuesAsBuffer) || displayHours !== displayHoursMax)
  ), [ displayWorkTypeTwoValues, editable, displayHours, displayHoursMax, maxValuesAsBuffer ]);
  
  const handleHoursChange = (hour, isMax) => {
    structure.historyManager.startGroup();
    let key = MinAvgMaxKeys.AVG;
    if(isMax)
      key = MinAvgMaxKeys.MAX;
    else if(!maxValuesAsBuffer && showMaxValue)
      key = MinAvgMaxKeys.MIN;
    
    hour = parseFloat((hour * modifier).toPrecision(12));
    const diff = hour - element.fixedHours?.[key];
    element.parent.updateResourceHours(element.id, diff, key);
    element.setFixedHours({ [key]: hour });
    structure.historyManager.stopGroup();
  };

  return (
    <ValueCell
      size="large"
      displayContent
      emptyInputs={!displayAnyValue}
      value={displayHours}
      valueMax={displayHoursMax}
      displayMax={showMaxValue}
      onValueChange={handleHoursChange}
      max={availableHours}
      editable={editable}
      showDecimals
      useSeparator={useProfitability}
      decimals={usedRoundDecimals}
      className={className}
      textPresetClass="preset-summaryText"
      inputClassName="input-hours"
      {...props}
      {...tooltip}
    />
  );
});

HoursCell.propTypes = {
  element: object.isRequired,
  extendPadding: bool,
};
